import React, {useEffect, useState} from "react";
import { makeStyles, withStyles} from "@material-ui/core";
import {withTranslation} from "react-i18next";
import * as colors from "../../../../constants/colors";
import clsx from "clsx";
import * as utils from "../../../../constants/utils";
import {useDispatch} from "react-redux";
import moment from "moment-timezone";
import _ from "lodash";
const styles = (theme)=>({
    table:{
        transform: "rotate(-90deg) scaleX(-1)",
        marginTop: "10%",
        marginLeft: "5%",
        "&>div:first-child,&>div:last-child":{
            zIndex:-1
        },
    },
    hex:{
        float: "left",
        position:"relative"
    },
    hexTitle:{
        transform: " scaleX(-1) rotate(90deg)",
        display: "flex",
        color: colors.PRIMARY_COLOR,
        fontWeight: "bold",
        position: "absolute",
        right: "calc(50% - 0.5rem)",
        bottom: "calc(50% - .5rem)",
    },
    hexLeft:{
        float: "left",
        width: 0
    },
    hexMiddle:{
        float: "left",
        position: "relative"

    },
    hexRight:{
        float: "left",
        width: 0
    },
    hexRow:{
        clear: "left"
    },
    mouseEnter:{
        cursor: "pointer",
        "&:not(:first-child):not(:last-child)>$hexLeft":{
            borderRightColor: colors.PRIMARY_COLOR_LIGHT+" !important"
        },
        "&:not(:first-child):not(:last-child)>$hexMiddle":{
            backgroundColor: colors.PRIMARY_COLOR_LIGHT+" !important"
        },
        "&:not(:first-child):not(:last-child)>$hexRight":{
            borderLeftColor: colors.PRIMARY_COLOR_LIGHT+" !important"
        }
    },
    borderBlack:{
        "&>$hexLeft":{
            borderRightColor: colors.DARK_COLOR+" !important"
        },
        "&>$hexMiddle":{
            backgroundColor: colors.DARK_COLOR+" !important"
        },
        "&>$hexRight":{
            borderLeftColor: colors.DARK_COLOR+" !important"
        },
        "& $hexTitle":{
            color: colors.PRIMARY_COLOR
        }
    },
    borderWhite:{
        "&>$hexLeft":{
            borderRightColor: colors.LIGHT_COLOR+" !important",
            transition : "border 500ms ease-out"
        },
        "&>$hexMiddle":{
            backgroundColor: colors.LIGHT_COLOR+" !important",
            transition : "border 500ms ease-out"
        },
        "&>$hexRight":{
            borderLeftColor: colors.LIGHT_COLOR+" !important",
            transition : "border 500ms ease-out"
        },
        "&$borderBlack":{
            "&>$hexLeft":{
                borderRightColor: "transparent !important",
                transition : "border 500ms ease-out"
            },
            "&>$hexMiddle":{
                backgroundColor: "transparent !important",
                transition : "border 500ms ease-out"
            },
            "&>$hexRight":{
                borderLeftColor: "transparent !important",
                transition : "border 500ms ease-out"
            }
        }
    },
    inConnectedPaths:{
        "&>$hexLeft":{
            borderRightColor: colors.PRIMARY_COLOR_DARK+" !important",
            transition : "border 1000ms ease-in"
        },
        "&>$hexMiddle":{
            backgroundColor: colors.PRIMARY_COLOR_DARK+" !important",
            transition : " background-color 1000ms ease-in"
        },
        "&>$hexRight":{
            borderLeftColor: colors.PRIMARY_COLOR_DARK+" !important",
            transition : "border 1000ms ease-in"
        },
    },
    lastStep:{
        "&>$hexLeft":{
            borderRightColor: colors.PRIMARY_COLOR+" !important",
            transition : "border 1000ms ease-in"
        },
        "&>$hexMiddle":{
            backgroundColor: colors.PRIMARY_COLOR+" !important",
            transition : " background-color 1000ms ease-in"
        },
        "&>$hexRight":{
            borderLeftColor: colors.PRIMARY_COLOR+" !important",
            transition : "border 1000ms ease-in"
        },
        "& $hexTitle":{
            color: colors.PRIMARY_COLOR
        }
    },
    tableBorder:{
    }
});

const useStyles = makeStyles(styles);

function Hexagon(props){
    const {x,y,sizeX,sizeY,color,tableSize,title,isPlaying,takeTokens,isTaken,isLastStep,inConnectedPaths} = props;
    const [mouseEnter,setMouseEnter] = useState(false);
    const classes = useStyles();
    const isClickable = isPlaying && x!==0 && y!==0 && x!==tableSize+1 && y!==tableSize+1 && !isTaken;
    const onClickHex = (e)=>{
        if (isPlaying && isClickable){
            takeTokens([{x:x,y:y}]);
        }
    }
    const [showLastStepColor,setShowLastStepColor] = useState(false);
    useEffect(()=>{
       if (isLastStep){
           setShowLastStepColor(true);
           setTimeout(()=>{
               setShowLastStepColor(false);
           },3000)
       }
    },[isLastStep]);
    const [showInConnectedPathColor,setShowInConnectedPathColor] = useState(false);
    useEffect(()=>{
        if (inConnectedPaths){
            setTimeout(()=>{
                setShowInConnectedPathColor(!showInConnectedPathColor);
            },3000)
        }
    },);
    return <div data-x={x} data-y={y} onClick={(e)=>onClickHex(e)} className={clsx(classes.hex,{[classes.mouseEnter]:mouseEnter && isClickable,[classes.tableBorder]:x===0||x===tableSize+1||y===0||y===tableSize+1,[classes.borderBlack]:x===0||x===tableSize+1,[classes.borderWhite]:y===0||y===tableSize+1,[classes.specialBorder]:(x===0 && y===0)||(x===tableSize+1 && y===tableSize+1),[classes.lastStep]:!!isLastStep && showLastStepColor,[classes.inConnectedPaths]:!!inConnectedPaths && !!showInConnectedPathColor})} onMouseEnter={(e)=>setMouseEnter(true)} onMouseLeave={(e)=>setMouseEnter(false)} style={{marginRight: -sizeX/4+2,marginBottom: -sizeY*y/2+2,float:"left",marginTop:y*sizeY/2,zIndex:(x===0||x===tableSize+1?0:x)*(y===0||y===tableSize+1?0:y)}}>
        <div className={classes.hexLeft} style={{borderRight: sizeX/4+"px solid "+color, borderTop:sizeY/2+"px solid transparent", borderBottom:sizeY/2+"px solid transparent"}}/>
        <div className={classes.hexMiddle} style={{width: sizeX/2, height: sizeY, background: color}} data-title={title!==""?"true":"false"}><span className={classes.hexTitle}>{title}</span></div>
        <div className={classes.hexRight} style={{borderLeft: sizeX/4+"px solid "+color, borderTop:sizeY/2+"px solid transparent", borderBottom:sizeY/2+"px solid transparent"}}/>
    </div>;
}

function GameTable(props){
    const {classes,tableSize,width,height,t,isPlayer1Turn,steps,userInPlaying,player1,player2,takeTokens,stopped,connectedPaths} = props;
    const sizeX = Math.floor(width*0.7/(tableSize+1));
    const sizeY = Math.floor(height*0.7/(tableSize+1));
    console.log(steps);
    if (steps && steps.length){
        steps.sort((a,b)=>{
            const dateA = moment(a.createdAt).valueOf();
            const dateB = moment(b.createdAt).valueOf();
            return dateA-dateB;
        });
    }
    const lastStep = steps && steps.length?_.cloneDeep(steps).reverse().find((item)=>item.tokens!==null):null;
    console.log(lastStep);
    return <div className={classes.table} style={{width:width,height:height}}>
        {Array.apply(0, Array(tableSize+2)).map(function (value,x) {
            const axisX = x;
            return <div className={classes.hexRow} key={tableSize-x}>
                {Array.apply(0, Array(tableSize+2)).map(function (value,y) {
                    const axisY = y;
                    let color = colors.SECONDARY_COLOR_LIGHT;
                    let tokenStep;
                    if (axisY<tableSize+1 && axisY>0 && axisX>0 && axisX<tableSize+1 && !!steps){
                        tokenStep = steps.find((step)=>{
                            return step.tokens && step.tokens.some((tokenArr)=>{
                                return tokenArr.x === axisX && tokenArr.y === axisY;
                            })
                        });
                    }
                    if (tokenStep){
                        color = tokenStep.color === "WHITE" ? colors.LIGHT_COLOR:colors.DARK_COLOR;
                    }
                    let inConnectedPaths = false;
                    if (connectedPaths && connectedPaths.length){
                        inConnectedPaths = connectedPaths.some((connectedPath)=>connectedPath === axisX +"-"+axisY);
                    }
                    return <Hexagon
                        key={axisX+"-"+axisY}
                        x={axisX}
                        y={axisY}
                        title={axisX===0 && axisY>0 && axisY<tableSize+1?axisY:(axisY===0 && axisX>0 && axisX<tableSize+1?utils.convertNumberToLetters(axisX-1):"")}
                        isLastStep={lastStep && lastStep.tokens && lastStep.tokens[0].x===axisX && lastStep.tokens[0].y === axisY}
                        takeTokens={takeTokens}
                        inConnectedPaths={inConnectedPaths}
                        isPlaying={userInPlaying && isPlayer1Turn && !stopped}
                        tableSize={tableSize}
                        sizeX={sizeX}
                        sizeY={sizeY}
                        isTaken={color!==colors.SECONDARY_COLOR_LIGHT}
                        color={color}
                    />;
                })}
            </div>;
        })}
    </div>
}

export default withStyles(styles)(withTranslation()(GameTable));